import { createFileRoute, Navigate, useParams } from '@tanstack/react-router'

// 発注書アップロード画面の旧 URL。読み取り失敗の発注書を「下書き」と呼んでいた名残で /drafts だったため、
// 画面の役割に合わせて /upload へ移した（docs/issues/20261101_13_order-read-failed-naming.md）。
// ブックマーク・共有済みのリンクを壊さないようリダイレクトだけ残す
function LegacyDraftsRedirect() {
  const { tenant_id: tenantId } = useParams({ from: '/t/$tenant_id/order_line_matching/drafts' })
  return <Navigate to="/t/$tenant_id/order_line_matching/upload" params={{ tenant_id: tenantId }} replace />
}

export const Route = createFileRoute('/t/$tenant_id/order_line_matching/drafts')({
  component: LegacyDraftsRedirect,
})
